// "Recently saved" log for the sync chip popover (per device).
const KEY = "tycc_sync_history";
export const HISTORY_EVENT = "tycc-sync-history";
export const readHistory = () => { try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; } };
export const pushHistory = (labels) => {
  const items = (Array.isArray(labels) ? labels : [labels]).filter(Boolean).map((label) => ({ label, at: new Date().toISOString() }));
  if (!items.length) return;
  localStorage.setItem(KEY, JSON.stringify([...items.reverse(), ...readHistory()].slice(0, 20)));
  window.dispatchEvent(new Event(HISTORY_EVENT));
};
export const historyAgo = (iso) => {
  const s = Math.floor((Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)} min ago`;
  if (s < 86400) return `${Math.floor(s / 3600)} h ago`;
  return `${Math.floor(s / 86400)} d ago`;
};
